import * as React from 'react';
import { isBrowser, noop } from '@sravni/react-utils';

/** Счетчик открытых диалогов и шторок */
let dsGlobalOpenModalsCount = 0;
/** Вспомогательный индекс для определения направления Вперед/Назад и для смещения по history */
let dsGlobalHistoryOffset = 0;
/** Флаг для определения объектов в history, добавленных хуком */
const dsGlobalBlockForward = 'dsGlobalBlockForward';
const handleDsGlobalPopstate = (event) => {
    if (event.state[dsGlobalBlockForward] === true && dsGlobalHistoryOffset === 0) {
        window.history.replaceState({ ...window.history.state, [dsGlobalBlockForward]: true, dsGlobalHistoryOffset }, '');
        window.history.go(-1);
    }
};
/**
 * React hook executes closeHandler on back browser button click (or software simulation), especially useful in the Sheet and Dialog on mobile devices
 *
 * @param enable enabling of the hook
 * @param visible current state of the modal
 * @param closeHandler handler to be executed when the modal closes
 * @returns closeEventHandler
 * @example
 * ```javascript
 * const { closeEventHandler } = useBackwardEvent(closeOnBackward, !!visible, handleClose)
 * ```
 */
function useBackwardEvent(enable, visible, closeHandler) {
    const modalIndex = React.useRef(0);
    const handlePopstate = (event) => {
        if (modalIndex.current === dsGlobalOpenModalsCount - 1) {
            // если нажата кнопка Вперед
            if (dsGlobalHistoryOffset - 1 < event.state.dsGlobalHistoryOffset) {
                dsGlobalHistoryOffset += 1;
                return;
            }
            closeHandler?.(event);
            dsGlobalHistoryOffset -= 1;
        }
    };
    const handlePopstateRef = React.useRef(handlePopstate);
    const openEventHandler = () => {
        window.history.pushState({ ...window.history.state, [dsGlobalBlockForward]: true, dsGlobalHistoryOffset }, '');
        dsGlobalHistoryOffset += 1;
        dsGlobalOpenModalsCount += 1;
    };
    const closeEventHandler = () => {
        dsGlobalOpenModalsCount = dsGlobalOpenModalsCount > 1 ? dsGlobalOpenModalsCount - 1 : 0;
        if (dsGlobalOpenModalsCount === 0) {
            dsGlobalHistoryOffset && window.history.go(0 - dsGlobalHistoryOffset);
            dsGlobalHistoryOffset = 0;
        }
    };
    React.useEffect(() => {
        if (!isBrowser || !enable)
            return;
        const handleInnerPopstate = handlePopstateRef.current;
        if (visible) {
            modalIndex.current = dsGlobalOpenModalsCount;
            openEventHandler();
            window.addEventListener('popstate', handleInnerPopstate);
        }
        else {
            window.removeEventListener('popstate', handleInnerPopstate);
        }
        return () => {
            window.removeEventListener('popstate', handleInnerPopstate);
        };
    }, [enable, visible]);
    React.useEffect(() => {
        // TODO потенциальный баг при использовании enable в эффекте
        if (enable) {
            window.addEventListener('popstate', handleDsGlobalPopstate);
        }
    }, [enable]);
    if (!isBrowser || !enable)
        return { closeEventHandler: noop };
    return {
        closeEventHandler,
    };
}

export { useBackwardEvent };
//# sourceMappingURL=useBackwardEvent.js.map
